<script setup lang="ts">
const page = useStringParam("slug");

const {
  data: currentArticle,
  error,
  suspense,
} = useArticle(`/artikler/${page}`);

await suspense();

if (error.value) {
  throw createError(error.value);
}

if (!currentArticle.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Artikkelen finnes ikke",
    fatal: true,
  });
}

provide(keys.currentArticle, currentArticle.value);

// FIXME: Only fetch if there are not enough related articles
const cardsQuery = useArticleCards();

const articleCounts = useArticleReadCounts();

const cards = computed(() => {
  const allCards = cardsQuery.data.value;

  if (currentArticle.value?.showRelatedArticles && allCards) {
    const cards = [...currentArticle.value.relatedArticles];

    const missing = 3 - cards.length;

    if (missing > 0) {
      const relation =
        currentArticle.value.theme.length === 0
          ? currentArticle.value.subject.length === 0
            ? currentArticle.value.levels
            : currentArticle.value.subject
          : currentArticle.value.theme;

      if (relation.includes("univers")) {
        cards.push(...allCards.filter((it) => it.title?.includes("univers")));
      } else {
        cards.push(
          ...allCards.filter((it) =>
            relation.some(
              (rel) =>
                it.theme?.includes(rel) ||
                it.subject?.includes(rel) ||
                it.levels?.includes(rel as Level),
            ),
          ),
        );
      }
    }

    return cards.filter((it) => it.id !== currentArticle.value?.id);
  }

  return undefined;
});

useDocumentSeo(currentArticle.value, {
  ogType: "article",
});

onMounted(async () => {
  if (!currentArticle.value) {
    return;
  }

  try {
    // TODO: Should we count on mount or later?

    await articleCounts.suspense();

    if (articleCounts.error.value) {
      handleError(
        articleCounts.error.value,
        "Failed to fetch article counts",
        false,
      );
      return;
    }

    const counts = {
      ...articleCounts.data.value?.counts,
    };

    counts[currentArticle.value.id] ??= 0;
    counts[currentArticle.value.id]! += 1;

    if (!import.meta.dev) {
      await $fetch(`/api/article/${articleCounts.data.value?.id}/read-count`, {
        method: "PUT",
        body: JSON.stringify(counts),
      });
    }

    await articleCounts.refetch();
  } catch (e) {
    handleError(e, "Failed to update article views", false);
  }
});
</script>

<template>
  <div>
    <LayoutBreadCrumbs
      :background="true"
      :text-conversions="{ [page]: currentArticle?.title }"
    />
    <UiArticlesContent />
    <Content
      is="section"
      v-if="currentArticle?.ctaContent && currentArticle.ctaContent.length > 0"
      width="article"
      class="tablet:justify-left my-16 flex flex-col items-center justify-center gap-8 tablet:flex-row tablet:items-stretch"
    >
      <CtaForArticles :content="currentArticle.ctaContent.slice(0, 2)" />
    </Content>
    <ClientOnly>
      <UiStripesArticles
        v-if="currentArticle?.showRelatedArticles && cards?.length"
        class="yellow-light-green"
        :show-all="true"
        :articles="cards"
        :range="[0, 3]"
        title="Artikler"
      />
    </ClientOnly>
    <CtaNewsletter />
  </div>
</template>
